/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from "@mui/material";
import React from "react";

interface TypographyProps extends MuiTypographyProps {
  color?: keyof typeof colors;
}
type Props = TypographyProps & { component?: React.ElementType };

// Currently not used. Looking to replace use of current typography with this.
const Typography: React.FC<Props> = ({ color, ...props }) => {
  return <MuiTypography color={color ? colors[color] : undefined} {...props}></MuiTypography>;
};

export default Typography;
